import { createContext, useContext, useEffect, useState, useCallback } from "react";
import client from "@/lib/glossyApi";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("glossy_token");
    if (!token) {
      setUser(null);
      setMember(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await client.get("/auth/me");
      setUser(data.user);
      setMember(data.member);
    } catch {
      localStorage.removeItem("glossy_token");
      setUser(null);
      setMember(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await client.post("/auth/login", { email, password });
    localStorage.setItem("glossy_token", data.token);
    await refresh();
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await client.post("/auth/register", { name, email, password });
    localStorage.setItem("glossy_token", data.token);
    await refresh();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("glossy_token");
    setUser(null);
    setMember(null);
  };

  return (
    <AuthContext.Provider value={{ user, member, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
